import { LogIn, LogOut } from 'lucide-react';
import { type ReactElement } from 'react';

import { type ConversationEhrClockEvent } from '@apps/web/components/shared/messages/messages_timeline_utils';
import { TimelineEventRow } from '@apps/web/components/ui/timeline_event_row';
import { formatTime } from '@apps/web/lib/date_utils';

// A clock event the caregiver performed directly in the EHR (sync-observed).
// The label arrives fully composed from the API; the timestamp is the
// vendor's actual clock time.
export function EhrClockTimelineItem({
    event,
    timezone,
}: {
    readonly event: ConversationEhrClockEvent;
    readonly timezone: string;
}): ReactElement {
    return (
        <TimelineEventRow
            className="my-2 justify-center"
            icon={
                event.event_type === 'clock_in' ? (
                    <LogIn aria-hidden="true" />
                ) : (
                    <LogOut aria-hidden="true" />
                )
            }
        >
            <span className="min-w-0">{event.label}</span>
            <span className="shrink-0 text-gray-400">·</span>
            <span className="shrink-0 whitespace-nowrap tabular-nums">
                {formatTime(event.created_at, timezone)}
            </span>
        </TimelineEventRow>
    );
}
